import PropTypes from 'prop-types';
import React from 'react';

import Modal from '../../../common/Modal';
import PayoutForm from '../containers/PayoutFormContainer';

const PayoutModal = ({ close }) => (
  <Modal
    title="Payout / Pay-in"
    close={close}
    showCloseButton
  >
    <PayoutForm closePayoutModal={close} />
  </Modal>
);
PayoutModal.propTypes = {
  close: PropTypes.func.isRequired,
};

export default PayoutModal;
